// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"LegalDocumentsView_inputContainer__CfSAD"};